export const computeDismissedNewYearAlertStorageKey = currentYear => {
  return `Sales:Forecast:DismissedNewYearAlert:${currentYear}`;
};
export const DISMISSED_SET_CURRENCY_ALERT_STORAGE_KEY = 'Sales:Forecast:DismissedSetCurrencyAlert';
export const DISMISSED_AI_FORECASTING_V2_ALERT_STORAGE_KEY = 'Sales:Forecast:DismissedAIForecastingV2Alert';
export const DISMISSED_GOALS_BUG_ALERT_STORAGE_KEY = 'Sales:Forecast:DismissedGoalsBugAlert';